export default "__VITE_ASSET__Cex8Eegj__"